import { Label } from '@/components/shadcn/label';
import { Switch } from '@/components/shadcn/switch';
import { useUser } from '@/hooks/useUser';

interface Props {
  checked: boolean;
  onChange: (checked: boolean) => void;
}

export default function Benchmark({ checked, onChange }: Props) {
  const { user } = useUser();

  if (!user?.admin) return null;

  return (
    <div className="flex items-center space-x-2">
      <Switch id="airplane-mode" checked={checked} onCheckedChange={onChange} />
      <Label htmlFor="airplane-mode">Benchmark</Label>
    </div>
  );
}
